import { createContext, useContext } from "react";
import { ActiveGroup } from "../types/ActiveGroup";

export const GroupContext = createContext<ActiveGroup>(null!);

export const useGroupContext = () => useContext(GroupContext);
